import type { ServixSession, ServixUserType } from "../session/session";

export type AllowedRole = ServixUserType;

export type AuthStatus = "authenticated" | "anonymous";

export type AccessDecision = "allow" | "unauthenticated" | "forbidden";

export function getSessionRole(session: ServixSession | null): AllowedRole | null {
	return session?.user?.type_user ?? null;
}

export function canAccessByRole(
	role: AllowedRole | null,
	allowedRoles?: readonly AllowedRole[],
): boolean {
	if (!allowedRoles || allowedRoles.length === 0) return true;
	if (!role) return false;
	return allowedRoles.includes(role);
}

export function resolveAccessDecision(
	session: ServixSession | null,
	allowedRoles?: readonly AllowedRole[],
): AccessDecision {
	if (!session?.user?.id) return "unauthenticated";

	const role = getSessionRole(session);
	if (!canAccessByRole(role, allowedRoles)) return "forbidden";

	return "allow";
}

export function getHomeByRole(role: AllowedRole | null): string {
	switch (role) {
		case "Gerente":
			return "/admin/dashboard";
		case "Soporte":
			return "/admin/dashboard";
		case "Proveedor":
			return "/service/profile";
		case "Cliente":
			return "/profile";
		default:
			return "/";
	}
}
